/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CalculateValueView } from '../model/calculateValueView';
import { GetStockDiscrepancyDetailView } from '../model/getStockDiscrepancyDetailView';
import { HttpError } from '../model/httpError';
import { SearchStockDiscrepancyDetailView } from '../model/searchStockDiscrepancyDetailView';
import { StockDiscrepancyDetailInsert } from '../model/stockDiscrepancyDetailInsert';
import { StockDiscrepancyDetailUpdate } from '../model/stockDiscrepancyDetailUpdate';
import { StockDiscrepancyDetailView } from '../model/stockDiscrepancyDetailView';
import { UnitType } from '../model/unitType';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class StockDiscrepancyDetailsService {

    protected basePath = 'https://develop-sysnet-api.hlcloud.com.au';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Delete a StockDiscrepancyDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_stockdiscrepancydetails&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_venue_${venueId}_stockdiscrepancydetails’ where venueId is the cloud assigned ID for your venue.      &lt;br&gt;You can get a list of venues that you have access to through the /venues route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access: &#x27;sc_receive_stockdiscrepancydetails_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockDiscrepancyDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public stockDiscrepancyDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public stockDiscrepancyDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public stockDiscrepancyDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockDiscrepancyDetailsByExternalKeyIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/StockDiscrepancyDetails/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a StockDiscrepancyDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_stockdiscrepancydetails
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates FKExternalKeys   - **DiscrepancyIdFKObject:** discrepancyId, externalKeys  - **StockIdFKObject:** stockId, externalKeys  - **FactorIdFKObject:** factorId, externalKeys               
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockDiscrepancyDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'body', reportProgress?: boolean): Observable<GetStockDiscrepancyDetailView>;
    public stockDiscrepancyDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStockDiscrepancyDetailView>>;
    public stockDiscrepancyDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStockDiscrepancyDetailView>>;
    public stockDiscrepancyDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockDiscrepancyDetailsByExternalKeyIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetStockDiscrepancyDetailView>('get',`${this.basePath}/StockDiscrepancyDetails/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a StockDiscrepancyDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_stockdiscrepancydetails&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_venue_${venueId}_stockdiscrepancydetails’ where venueId is the cloud assigned ID for your venue.      &lt;br&gt;You can get a list of venues that you have access to through the /venues route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access: &#x27;sc_receive_stockdiscrepancydetails_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its user specific unique external key
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockDiscrepancyDetailsByExternalKeyIdPut(id: string, body?: StockDiscrepancyDetailUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<StockDiscrepancyDetailView>>;
    public stockDiscrepancyDetailsByExternalKeyIdPut(id: string, body?: StockDiscrepancyDetailUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StockDiscrepancyDetailView>>>;
    public stockDiscrepancyDetailsByExternalKeyIdPut(id: string, body?: StockDiscrepancyDetailUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StockDiscrepancyDetailView>>>;
    public stockDiscrepancyDetailsByExternalKeyIdPut(id: string, body?: StockDiscrepancyDetailUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockDiscrepancyDetailsByExternalKeyIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<StockDiscrepancyDetailView>>('put',`${this.basePath}/StockDiscrepancyDetails/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Calculates a number of fields required for display in the discrepancy screen based upon the unit type selected.
     * @param locationId Location Id
     * @param stockId 
     * @param unitAdjustmentQty 
     * @param unitType 
     * @param factorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockDiscrepancyDetailsCalculateValuesGet(locationId: number, stockId: number, unitAdjustmentQty: number, unitType: UnitType, factorId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CalculateValueView>>;
    public stockDiscrepancyDetailsCalculateValuesGet(locationId: number, stockId: number, unitAdjustmentQty: number, unitType: UnitType, factorId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CalculateValueView>>>;
    public stockDiscrepancyDetailsCalculateValuesGet(locationId: number, stockId: number, unitAdjustmentQty: number, unitType: UnitType, factorId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CalculateValueView>>>;
    public stockDiscrepancyDetailsCalculateValuesGet(locationId: number, stockId: number, unitAdjustmentQty: number, unitType: UnitType, factorId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (locationId === null || locationId === undefined) {
            throw new Error('Required parameter locationId was null or undefined when calling stockDiscrepancyDetailsCalculateValuesGet.');
        }

        if (stockId === null || stockId === undefined) {
            throw new Error('Required parameter stockId was null or undefined when calling stockDiscrepancyDetailsCalculateValuesGet.');
        }

        if (unitAdjustmentQty === null || unitAdjustmentQty === undefined) {
            throw new Error('Required parameter unitAdjustmentQty was null or undefined when calling stockDiscrepancyDetailsCalculateValuesGet.');
        }

        if (unitType === null || unitType === undefined) {
            throw new Error('Required parameter unitType was null or undefined when calling stockDiscrepancyDetailsCalculateValuesGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (locationId !== undefined && locationId !== null) {
            queryParameters = queryParameters.set('locationId', <any>locationId);
        }
        if (stockId !== undefined && stockId !== null) {
            queryParameters = queryParameters.set('stockId', <any>stockId);
        }
        if (unitAdjustmentQty !== undefined && unitAdjustmentQty !== null) {
            queryParameters = queryParameters.set('unitAdjustmentQty', <any>unitAdjustmentQty);
        }
        if (unitType !== undefined && unitType !== null) {
            queryParameters = queryParameters.set('unitType', <any>unitType);
        }
        if (factorId !== undefined && factorId !== null) {
            queryParameters = queryParameters.set('factorId', <any>factorId);
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/html'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CalculateValueView>>('get',`${this.basePath}/stockDiscrepancyDetails/calculateValues`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Search for StockDiscrepancyDetail objects&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_stockdiscrepancydetails
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates StockDiscrepancyDetailList   - **Stock:** name, type, inventoryCode, innersPerOuter, inners, outers, lastCost, averageCost  - **Discrepancy:** locationId, processed, discrepancyType  FKExternalKeys   - **DiscrepancyIdFKObject:** discrepancyId, externalKeys  - **StockIdFKObject:** stockId, externalKeys  - **FactorIdFKObject:** factorId, externalKeys               
     * @param group This parameter is used to group results.                         The fieldName can be any of the following: discrepancyId, stockId, factorId.                         The sort could either have - to sort by descending and + to sort by ascending. See groupQuery schema for more info.                         For grouping using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param groupSummary This parameter is used to summarise grouped results by aggregating the groups.                 The fieldName can be any of the following: discrepancyDetailId, discrepancyId, stockId, qtyInStock, adjustmentQty, adjustmentValue, factorId, unitAdjustmentQty.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param totalSummary This parameter is used to summarise all grouped results by aggregating all the groups sub groups.                 The fieldName can be any of the following: discrepancyDetailId, discrepancyId, stockId, qtyInStock, adjustmentQty, adjustmentValue, factorId, unitAdjustmentQty.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param searchDistinct This parameter is used to get the distinct values for a field.                  Only the field specified will be returned in the results. This can be used with filtering functionality, sort and limit.                  However it cannot be used with group, groupSummary or totalSummary.
     * @param sort This parameter is used to change the sorting of results returned.                          The default sort is discrepancyDetailId ascending.                          Use any fieldNames comma separated in the sort.                          Use + for ascending - for descending                          eg +updateDateTime.                         - discrepancyDetailId would sort by updateDateTime ascending and then discrepancyDetailId descending.  For sorting using a nested field use &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested levels eg +Stock.name                         For sorting using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param limit This limits the amount of results returned. This default limit Is set to 20. The maximum limit is 200.
     * @param offset This parameter is used to change the default offset from 0. Offset is the position in the dataset of a particular record. By specifying offset, you retrieve a subset of records starting with the offset value. Eg: If you have 100 records in your result set, and you want to retrieve records 50 to 80, you will need to use offset&#x3D;49 and limit &#x3D; 30.
     * @param search This does an &lt;b&gt;advanced&lt;/b&gt; search using a url encoded JSON object. &lt;br&gt;&lt;br&gt;  Most fields available in the return object can be searched using this methodology. &lt;br&gt;Example: search&#x3D;{ \&quot;status\&quot;: \&quot;active\&quot;} would search the status field for the value: &#x27;active&#x27;.&lt;br&gt;&lt;br&gt;  Searching is also possible using nested fields. Use the following syntax: &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested field.&lt;br&gt; Example: search&#x3D;{ \&quot;Stock.name\&quot;: \&quot;Best Beer\&quot; }&lt;br&gt;&lt;br&gt;  There are a couple of extra operators that can be used in the search. These are $or, $and, $not. &lt;br&gt; Example: search&#x3D;{ \&quot;$or\&quot;: [ { \&quot;status\&quot;: \&quot;bad\&quot; }, { \&quot;status\&quot;: \&quot;worse\&quot; } ] }. Searches for the statuses of &#x27;bad&#x27; or &#x27;worse&#x27;.&lt;br&gt; The $or, $and and $not operators can be nested.&lt;br&gt;&lt;br&gt;  If the name pair contains a fieldName it is possible for the value to be a sub-object containing any number of operators. The operators depend on the fieldType of the fieldName:&lt;br&gt;&lt;br&gt; &lt;b&gt;Date time Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $gt, $gte, $lt, $lte, $in&lt;br&gt; Example: search&#x3D;{ \&quot;startTime\&quot;: { \&quot;$gt\&quot;: \&quot;2 November 2021\&quot; } }&lt;br&gt;&lt;br&gt; &lt;b&gt;Relative Date time Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $gt, $gte, $lt, $lte, $in&lt;br&gt; Example: search&#x3D;{ \&quot;startTime\&quot;: { \&quot;$gt\&quot;: \&quot;2 November 2021\&quot; } }&lt;br&gt; &lt;em&gt;This &#x27;relativeDateTime&#x27; field is relative to the timezone a user resides in and is not an absolute point in time&lt;/em&gt;&lt;br&gt;&lt;br&gt; &lt;b&gt;Number Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $gt, $gte, $lt, $lte, $between, $notBetween, $in, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;totalCount\&quot;: { \&quot;$gt\&quot;: 10 } } &lt;br&gt;&lt;br&gt; &lt;b&gt;String Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $in, $like, $iLike, $notLike, $notILike, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;failReason\&quot;: { \&quot;$in\&quot;: [\&quot;Out of bounds\&quot;, \&quot;Out of time\&quot;] } }&lt;br&gt;&lt;br&gt;  These operators equate to Sequelize operators. See &lt;a href&#x3D;\&quot;https://sequelize.org/docs/v7/querying/operators\&quot;&gt;Operators | Sequelize&lt;/a&gt;
     * @param discrepancyDetailId The unique identifier of this record.&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the discrepancyDetailId field and returns all available results that match.   You can use &gt;10 to search for all discrepancyDetailIds greater than 10. You can use [1,2,3] to search for discrepancyDetailIds that match either 1, 2 or 3. You can use this parameter multiple times. eg discrepancyDetailId&#x3D;&gt;5&amp; discrepancyDetailId&#x3D;&lt;10 would search for all discrepancyDetailIds between 5 and 10.
     * @param discrepancyId A reference to the primary key in the StockDiscrepancyHeaders Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the discrepancyId field and returns all available results that match.   You can use &gt;10 to search for all discrepancyIds greater than 10. You can use [1,2,3] to search for discrepancyIds that match either 1, 2 or 3. You can use this parameter multiple times. eg discrepancyId&#x3D;&gt;5&amp; discrepancyId&#x3D;&lt;10 would search for all discrepancyIds between 5 and 10.
     * @param stockId A reference to the primary key in the Stock Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the stockId field and returns all available results that match.   You can use &gt;10 to search for all stockIds greater than 10. You can use [1,2,3] to search for stockIds that match either 1, 2 or 3. You can use this parameter multiple times. eg stockId&#x3D;&gt;5&amp; stockId&#x3D;&lt;10 would search for all stockIds between 5 and 10.
     * @param qtyInStock &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the qtyInStock field and returns all available results that match.   You can use &gt;10 to search for all qtyInStocks greater than 10. You can use [1,2,3] to search for qtyInStocks that match either 1, 2 or 3. You can use this parameter multiple times. eg qtyInStock&#x3D;&gt;5&amp; qtyInStock&#x3D;&lt;10 would search for all qtyInStocks between 5 and 10.
     * @param adjustmentQty &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the adjustmentQty field and returns all available results that match.   You can use &gt;10 to search for all adjustmentQtys greater than 10. You can use [1,2,3] to search for adjustmentQtys that match either 1, 2 or 3. You can use this parameter multiple times. eg adjustmentQty&#x3D;&gt;5&amp; adjustmentQty&#x3D;&lt;10 would search for all adjustmentQtys between 5 and 10.
     * @param adjustmentValue &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the adjustmentValue field and returns all available results that match.   You can use &gt;10 to search for all adjustmentValues greater than 10. You can use [1,2,3] to search for adjustmentValues that match either 1, 2 or 3. You can use this parameter multiple times. eg adjustmentValue&#x3D;&gt;5&amp; adjustmentValue&#x3D;&lt;10 would search for all adjustmentValues between 5 and 10.
     * @param reason &lt;br&gt;This parameter searches for the reason field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param createDateTime The date and time this record was created.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the createDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all createDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for createDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg createDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; createDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all createDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param updateDateTime The last date and time this record was updated.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the updateDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all updateDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for updateDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg updateDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; updateDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all updateDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param lastUpdateByUserId The userId of the last person to modify this record.&lt;br&gt;This parameter searches for the lastUpdateByUserId field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param unitType &lt;br&gt;This parameter searches for the unitType field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param factorId A reference to the primary key in the Factors Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the factorId field and returns all available results that match.   You can use &gt;10 to search for all factorIds greater than 10. You can use [1,2,3] to search for factorIds that match either 1, 2 or 3. You can use this parameter multiple times. eg factorId&#x3D;&gt;5&amp; factorId&#x3D;&lt;10 would search for all factorIds between 5 and 10.
     * @param unitAdjustmentQty &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the unitAdjustmentQty field and returns all available results that match.   You can use &gt;10 to search for all unitAdjustmentQtys greater than 10. You can use [1,2,3] to search for unitAdjustmentQtys that match either 1, 2 or 3. You can use this parameter multiple times. eg unitAdjustmentQty&#x3D;&gt;5&amp; unitAdjustmentQty&#x3D;&lt;10 would search for all unitAdjustmentQtys between 5 and 10.
     * @param verified &lt;br&gt;This parameter searches for the verified field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param verifyDate &lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the verifyDate field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all verifyDates greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for verifyDates that match either 1, 2 or 3. You can use this parameter multiple times. eg verifyDate&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; verifyDate&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all verifyDates between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param externalKey The unique external key set by the current user accessing the API&lt;br&gt;This parameter searches for the externalKey field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param organisationId Allows an api user to filter results by 1 or more organisationIds. To use multiple organisationIds: organisationId&#x3D;[org1,org2]
     * @param venueId Allows an api user to filter results by 1 or more venueIds. To use multiple organisationIds: venueId&#x3D;[venueId1,venueId2]
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockDiscrepancyDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, discrepancyDetailId?: number, discrepancyId?: number, stockId?: number, qtyInStock?: string, adjustmentQty?: string, adjustmentValue?: string, reason?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, unitType?: string, factorId?: number, unitAdjustmentQty?: string, verified?: string, verifyDate?: string, externalKey?: string, organisationId?: string, venueId?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchStockDiscrepancyDetailView>;
    public stockDiscrepancyDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, discrepancyDetailId?: number, discrepancyId?: number, stockId?: number, qtyInStock?: string, adjustmentQty?: string, adjustmentValue?: string, reason?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, unitType?: string, factorId?: number, unitAdjustmentQty?: string, verified?: string, verifyDate?: string, externalKey?: string, organisationId?: string, venueId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchStockDiscrepancyDetailView>>;
    public stockDiscrepancyDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, discrepancyDetailId?: number, discrepancyId?: number, stockId?: number, qtyInStock?: string, adjustmentQty?: string, adjustmentValue?: string, reason?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, unitType?: string, factorId?: number, unitAdjustmentQty?: string, verified?: string, verifyDate?: string, externalKey?: string, organisationId?: string, venueId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchStockDiscrepancyDetailView>>;
    public stockDiscrepancyDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, discrepancyDetailId?: number, discrepancyId?: number, stockId?: number, qtyInStock?: string, adjustmentQty?: string, adjustmentValue?: string, reason?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, unitType?: string, factorId?: number, unitAdjustmentQty?: string, verified?: string, verifyDate?: string, externalKey?: string, organisationId?: string, venueId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





























        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }
        if (group !== undefined && group !== null) {
            queryParameters = queryParameters.set('group', <any>group);
        }
        if (groupSummary !== undefined && groupSummary !== null) {
            queryParameters = queryParameters.set('groupSummary', <any>groupSummary);
        }
        if (totalSummary !== undefined && totalSummary !== null) {
            queryParameters = queryParameters.set('totalSummary', <any>totalSummary);
        }
        if (searchDistinct !== undefined && searchDistinct !== null) {
            queryParameters = queryParameters.set('searchDistinct', <any>searchDistinct);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (discrepancyDetailId !== undefined && discrepancyDetailId !== null) {
            queryParameters = queryParameters.set('discrepancyDetailId', <any>discrepancyDetailId);
        }
        if (discrepancyId !== undefined && discrepancyId !== null) {
            queryParameters = queryParameters.set('discrepancyId', <any>discrepancyId);
        }
        if (stockId !== undefined && stockId !== null) {
            queryParameters = queryParameters.set('stockId', <any>stockId);
        }
        if (qtyInStock !== undefined && qtyInStock !== null) {
            queryParameters = queryParameters.set('qtyInStock', <any>qtyInStock);
        }
        if (adjustmentQty !== undefined && adjustmentQty !== null) {
            queryParameters = queryParameters.set('adjustmentQty', <any>adjustmentQty);
        }
        if (adjustmentValue !== undefined && adjustmentValue !== null) {
            queryParameters = queryParameters.set('adjustmentValue', <any>adjustmentValue);
        }
        if (reason !== undefined && reason !== null) {
            queryParameters = queryParameters.set('reason', <any>reason);
        }
        if (createDateTime !== undefined && createDateTime !== null) {
            queryParameters = queryParameters.set('createDateTime', <any>createDateTime);
        }
        if (updateDateTime !== undefined && updateDateTime !== null) {
            queryParameters = queryParameters.set('updateDateTime', <any>updateDateTime);
        }
        if (lastUpdateByUserId !== undefined && lastUpdateByUserId !== null) {
            queryParameters = queryParameters.set('lastUpdateByUserId', <any>lastUpdateByUserId);
        }
        if (unitType !== undefined && unitType !== null) {
            queryParameters = queryParameters.set('unitType', <any>unitType);
        }
        if (factorId !== undefined && factorId !== null) {
            queryParameters = queryParameters.set('factorId', <any>factorId);
        }
        if (unitAdjustmentQty !== undefined && unitAdjustmentQty !== null) {
            queryParameters = queryParameters.set('unitAdjustmentQty', <any>unitAdjustmentQty);
        }
        if (verified !== undefined && verified !== null) {
            queryParameters = queryParameters.set('verified', <any>verified);
        }
        if (verifyDate !== undefined && verifyDate !== null) {
            queryParameters = queryParameters.set('verifyDate', <any>verifyDate);
        }
        if (externalKey !== undefined && externalKey !== null) {
            queryParameters = queryParameters.set('externalKey', <any>externalKey);
        }
        if (organisationId !== undefined && organisationId !== null) {
            queryParameters = queryParameters.set('organisationId', <any>organisationId);
        }
        if (venueId !== undefined && venueId !== null) {
            queryParameters = queryParameters.set('venueId', <any>venueId);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SearchStockDiscrepancyDetailView>('get',`${this.basePath}/StockDiscrepancyDetails/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a StockDiscrepancyDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_stockdiscrepancydetails&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_venue_${venueId}_stockdiscrepancydetails’ where venueId is the cloud assigned ID for your venue.      &lt;br&gt;You can get a list of venues that you have access to through the /venues route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access: &#x27;sc_receive_stockdiscrepancydetails_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockDiscrepancyDetailsIdDelete(id: number, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public stockDiscrepancyDetailsIdDelete(id: number, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public stockDiscrepancyDetailsIdDelete(id: number, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public stockDiscrepancyDetailsIdDelete(id: number, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockDiscrepancyDetailsIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/StockDiscrepancyDetails/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a StockDiscrepancyDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_stockdiscrepancydetails
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates FKExternalKeys   - **DiscrepancyIdFKObject:** discrepancyId, externalKeys  - **StockIdFKObject:** stockId, externalKeys  - **FactorIdFKObject:** factorId, externalKeys               
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockDiscrepancyDetailsIdGet(id: number, ridChain?: string, view?: string, observe?: 'body', reportProgress?: boolean): Observable<GetStockDiscrepancyDetailView>;
    public stockDiscrepancyDetailsIdGet(id: number, ridChain?: string, view?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStockDiscrepancyDetailView>>;
    public stockDiscrepancyDetailsIdGet(id: number, ridChain?: string, view?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStockDiscrepancyDetailView>>;
    public stockDiscrepancyDetailsIdGet(id: number, ridChain?: string, view?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockDiscrepancyDetailsIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetStockDiscrepancyDetailView>('get',`${this.basePath}/StockDiscrepancyDetails/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a StockDiscrepancyDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_stockdiscrepancydetails&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_venue_${venueId}_stockdiscrepancydetails’ where venueId is the cloud assigned ID for your venue.      &lt;br&gt;You can get a list of venues that you have access to through the /venues route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access: &#x27;sc_receive_stockdiscrepancydetails_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its unique ID
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockDiscrepancyDetailsIdPut(id: number, body?: StockDiscrepancyDetailUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<StockDiscrepancyDetailView>>;
    public stockDiscrepancyDetailsIdPut(id: number, body?: StockDiscrepancyDetailUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StockDiscrepancyDetailView>>>;
    public stockDiscrepancyDetailsIdPut(id: number, body?: StockDiscrepancyDetailUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StockDiscrepancyDetailView>>>;
    public stockDiscrepancyDetailsIdPut(id: number, body?: StockDiscrepancyDetailUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockDiscrepancyDetailsIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<StockDiscrepancyDetailView>>('put',`${this.basePath}/StockDiscrepancyDetails/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Creates a new StockDiscrepancyDetail&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_insert_stockdiscrepancydetails&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_venue_${venueId}_stockdiscrepancydetails’ where venueId is the cloud assigned ID for your venue.      &lt;br&gt;You can get a list of venues that you have access to through the /venues route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access: &#x27;sc_receive_stockdiscrepancydetails_events&#x27; to receive events on this route.
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockDiscrepancyDetailsPost(body?: StockDiscrepancyDetailInsert, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<StockDiscrepancyDetailView>;
    public stockDiscrepancyDetailsPost(body?: StockDiscrepancyDetailInsert, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StockDiscrepancyDetailView>>;
    public stockDiscrepancyDetailsPost(body?: StockDiscrepancyDetailInsert, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StockDiscrepancyDetailView>>;
    public stockDiscrepancyDetailsPost(body?: StockDiscrepancyDetailInsert, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<StockDiscrepancyDetailView>('post',`${this.basePath}/StockDiscrepancyDetails/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
